export function getUserData(setUserData) {
    let cookieData = JSON.parse(decodeURIComponent(getCookie('user-info')));
    let loggedIn = getCookie('user-info-logged-in');
    if(cookieData) {
        updateUserNavElements(loggedIn, cookieData, setUserData);
        setAnalyticsUserProperties(cookieData);
    } else {
        clearSessionLoginState();
    }

    const NotificationHolder = document.getElementById('notificationHolder');
    if (!NotificationHolder) { return; }
    //NotificationHolder.innerHTML = userData.notification;


    // This code assumes that there is only ever ONE notification; if we refactor to allow for many/serial/sequential notifications, this will need to change.
    const $notification = NotificationHolder.querySelector('.notification-holder');
    if (!$notification) return;

    const COOKIE_REFERENCE = $notification.dataset.token;
    const COOKIE_TTL_DAYS = parseInt($notification.dataset.ttl, 10) || 30;

    const hasDismissalCookie = Cookies.get(COOKIE_REFERENCE) !== undefined;

    if (!hasDismissalCookie) {
        requestAnimationFrame(() => {
            $notification.classList.remove('closed');
        });
    }

    function dismissNotification() {
        Cookies.set(COOKIE_REFERENCE, Date.now(), { expires: COOKIE_TTL_DAYS });
        $notification.classList.add('closed');
    }

    NotificationHolder.addEventListener('click', (event) => {
        const $clicked = event.target;
        if ($clicked.closest('.closeBtn') || $clicked.closest('.cta')) {
            dismissNotification();
        }
    });
}

const analyticsUserPropWhitelist = Array('display_name', 'country_code', 'site_language', 'user_id', 'mastery_rank', 'platinum', 'coupon', 'twitch_linked', 'game_platform');
function setAnalyticsUserProperties(userData)
{
    if (typeof analytics === 'undefined')
    {
        return;
    }
    let camel_to_snake = (str) => str.replace(/(\B)([A-Z])/, '_$2').toLowerCase();
    let user_props = {};
    for (const [key, value] of Object.entries(userData)) {
        if (analyticsUserPropWhitelist.indexOf(key) !== -1) {
            user_props[camel_to_snake(key)] = value;
        }
    }

    analytics.set_user_properties(user_props);

    analytics.event("user_properties_ready")
        .properties({"authenticated": !!userData })
        .push();
}

const SESSION_STORAGE_LOGIN_STATE = "wfSessionShouldBeLoggedIn";
const SESSION_STORAGE_LOGGED_IN = "isLoggedIn";

function clearSessionLoginState() {
    if (safeSessionStorage()) {
        sessionStorage.removeItem(SESSION_STORAGE_LOGIN_STATE);
    }
    const body = document.querySelector('body');
    body.classList.toggle('logged-in', false);
    body.classList.toggle('loaded-in', false);
    body.classList.toggle('logged-out', true);
}

function safeSessionStorage() {
    try {
        return sessionStorage;
    } catch (e) {
        return false;
    }
}

let navDisplayName = '-';

function updateUserNavElements(loggedIn, cookieData, setUserData) {
    loggedIn = !!loggedIn;
    let body = document.querySelector('body');
    if (loggedIn) {
        body.classList.toggle('logged-in', loggedIn);
        body.classList.toggle('loaded-in', loggedIn);
        body.classList.toggle('logged-out', !loggedIn);
        if (safeSessionStorage()) {
            sessionStorage.setItem(SESSION_STORAGE_LOGIN_STATE, SESSION_STORAGE_LOGGED_IN);
        }
    } else {
        clearSessionLoginState();
    }
    if (!cookieData.display_name) {
        cookieData.display_name = '-';
    }

    if (window.isLoggedIn === loggedIn && navDisplayName === cookieData.display_name) {
        return; //nothing changed
    }
    window.isLoggedIn = loggedIn;
    navDisplayName = cookieData.display_name;

    let loggedInElements = document.querySelectorAll('.logged-in');
    let loggedOutElements = document.querySelectorAll('.not-logged-in');

    if(loggedIn) {
        setUserData(cookieData);

        loggedInElements.forEach(element => {
            element.classList.remove('login-hide');
        });
        loggedOutElements.forEach(element => {
            element.classList.add('login-hide');
        });
    } else {
        loggedInElements.forEach(element => {
            element.classList.add('login-hide');
        });
        loggedOutElements.forEach(element => {
            element.classList.remove('login-hide');
        });
    }
}
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}
